import React, { useEffect, useRef, useState } from "react";
import CanvasBox from "../../components/3d-scene/CanvasBox";
import { connect, useSelector } from "react-redux";
import { setColor } from "../../helper/threeHeper";
import { Box3, DoubleSide, Plane, Vector3 } from "three";
import ReactUI from "../reactui";
import { useHistory } from "react-router-dom";
import { gsap } from "gsap";
import { useMemo } from "react";

const RefCanvasBox = React.forwardRef((props, ref) => (
  <CanvasBox ref={ref} {...props} />
));
RefCanvasBox.displayName = "RefCanvasBox";

let activeObjectIds = [];

const Presentation = (props) => {
  const { roles, authMiddleware } = props;
  const [setIsIntroduction] = useState(false);
  const controls = useRef();
  let refScene = useRef();
  const history = useHistory();

  const TOPMOST_VERTEX_Y = 140;

  const page = useSelector((state) => state.home.page);
  const unitIds = useSelector((state) => state.unitExplore.units).map((item) => item["3d_asset"]?.id);

  useEffect(() => {
    authMiddleware(roles, history);
  }, []);

  let activeColorModel = {};

  function setActiveObjectIds(ids) {
    let prevIds = [];
    for (const index in activeObjectIds) {
      if (!ids.includes(activeObjectIds[index])) {
        prevIds.push(activeObjectIds[index]);
      }
    }
    handleResetObjectColor(prevIds);
    activeObjectIds = ids;
    handleSetActiveObjectColor();
  }

  function resetActiveColorModel(model) {
    activeColorModel = model;
  }

  const handleResetObjectColor = async (prevIds = []) => {
    refScene.current &&
      (prevIds || []).forEach((item) => {
        let objectSelector = refScene.current.getObjectByName(item);
        if (objectSelector) {
          setColor(
            objectSelector.userData.color,
            objectSelector.userData.active_alpha,
            objectSelector,
            objectSelector.userData.emissive,
          );
          objectSelector.userData.isActive = false;
        }
      });
  };

  const handleSetActiveObjectColor = () => {
    refScene.current &&
      (activeObjectIds || []).forEach((item) => {
        let objectSelector = refScene.current.getObjectByName(item);
        if (objectSelector) {
          let activeColor =
            activeColorModel["" + item]?.colorCode ??
            objectSelector.userData.active_color;
          setColor(
            activeColor,
            objectSelector.userData.active_alpha,
            objectSelector,
            objectSelector.userData.active_emissive,
          );
          objectSelector.userData.isActive = true;
        }
      });
  };

  return (
    <>
      {
        !props.isLoading &&
        <CanvasBox
          isPresentation={true}
          ref={refScene}
          controls={controls}
          objects={props.assets}
          hotspots={props.hotspots}
          activeObjectIds={[]}
          setActiveObjectIds={setActiveObjectIds}
          _3dSetting={props.settings}
          fbxs={props.fbxs}
          pagesSettings={props.pagesSettings}
          isIntroduction={true}
          targetPosition={controls.current?.getCurrentTarget() ?? new Vector3()}
        />
      }
      <ReactUI
        isPresentation={true}
        setIsIntroduction={setIsIntroduction}
        controls={controls}
        refScene={refScene}
        setActiveObjectIds={setActiveObjectIds}
        resetActiveColorModel={resetActiveColorModel}
        activeObjectIds={activeObjectIds}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const { scene } = state;
  return {
    settings: scene.settings,
    assets: scene.assets,
    hotspots: scene.hotspots,
    fbxs: scene.fbxs,
    isLoading: scene.isLoading,
    pagesSettings: scene.pagesSettings,
  };
};
export default connect(mapStateToProps)(Presentation);
